import { useCustomMutation } from '../../hooks/useCustomMutation';
import * as ENDPOINTS from './endpoints';

const QUERY_KEYS = {
  goalsData: 'goalsData',
};

export const useDeleteGoal = () => {
  return useCustomMutation([QUERY_KEYS.goalsData], ENDPOINTS.deleteGoal);
};
